import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ColorsTab } from '../components/ColorsTab';
import { LogosTab } from '../components/LogosTab';
import { PersonasTab } from '../components/PersonasTab';
import { ImagesTab } from '../components/ImagesTab';
import { EmailSignatureTab } from '../components/EmailSignatureTab';

export function BrandPage() {
  return (
    <div className="p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">Brand</h1>
        <p className="text-sm text-muted-foreground">
          ATEK brand guide — colors, logos, personas, and official imagery.
        </p>
      </div>

      <Tabs defaultValue="colors" className="w-full">
        <TabsList>
          <TabsTrigger value="colors">Colors</TabsTrigger>
          <TabsTrigger value="logos">Logos</TabsTrigger>
          <TabsTrigger value="personas">Personas</TabsTrigger>
          <TabsTrigger value="images">Official Images</TabsTrigger>
          <TabsTrigger value="signature">Email Signature</TabsTrigger>
        </TabsList>

        <TabsContent value="colors" className="mt-4"><ColorsTab /></TabsContent>
        <TabsContent value="logos" className="mt-4"><LogosTab /></TabsContent>
        <TabsContent value="personas" className="mt-4"><PersonasTab /></TabsContent>
        <TabsContent value="images" className="mt-4"><ImagesTab /></TabsContent>
        <TabsContent value="signature" className="mt-4"><EmailSignatureTab /></TabsContent>
      </Tabs>
    </div>
  );
}
